const MAX_LOG_OBSERVATION_TIME_PERIOD = 18;

export default MAX_LOG_OBSERVATION_TIME_PERIOD;
